export default {
  namespaced: true,
  video_wall: {
    assign_a_video_wall:"Atribuir ao videoWall",
    video_wall_users: "Usuários de video wall",
    no_view_assigned: "invisível",
  },
};
